import React, { useState } from 'react';
import { Tab, Tabs } from '@mui/material';

import PageContainer from '../../../components/layout/PageContainer';
import { TabPanel } from '../../../pages/billings/common';
import TPActivationLogs from './TPActivationLogs';
import { FHPageLink } from '../../../components/base';

export enum TPManagementTabs {
  UpdateTPActivationLog = 0,
}

// Tab index
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ManageTreatmentPlan: React.FC = () => {
  const [activeTab, setActiveTab] = useState<number>(TPManagementTabs.UpdateTPActivationLog);

  return (
    <PageContainer sx={{ px: 3, pt: 2 }}>
      <FHPageLink to="/admin" label="Admin Home" />
      {/* Contains single tab at the moment, we are going to add more tabs shortly for TP management*/}
      <Tabs
        aria-label="Tabs"
        sx={{
          minHeight: 32,
          '& .MuiTab-root': {
            padding: '0 0.5rem',
            textTransform: 'none',
            fontWeight: 400,
            minHeight: 32,
          },
        }}
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
      >
        <Tab
          label="Update TP Activation Logs"
          {...a11yProps(0)}
          value={TPManagementTabs.UpdateTPActivationLog}
          data-testid="updateTPActivationLogTab"
        />
      </Tabs>
      <TabPanel value={activeTab} index={TPManagementTabs.UpdateTPActivationLog}>
        <TPActivationLogs />
      </TabPanel>
    </PageContainer>
  );
};

export default ManageTreatmentPlan;
